"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLabRequisitionList = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const utils_1 = require("../utils");
const useDebouncedAbortableCall_1 = require("./useDebouncedAbortableCall");
const useLabRequisitionList = (groupInfo) => {
    const { selectedOrgUser } = (0, react_1.useContext)(context_1.OrganizationContext);
    const { labRequisitions } = (0, react_1.useContext)(context_1.LabRequisitionsContext);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const fetchLabRequisitions = (0, useDebouncedAbortableCall_1.useDebouncedAbortableCall)((abortContext) => __awaiter(void 0, void 0, void 0, function* () {
        if (!!selectedOrgUser && !!groupInfo) {
            yield selectedOrgUser.labsManager.getLabRequisitions(groupInfo.id, abortContext);
        }
    }), utils_1.Constants.API_DEBOUNCE_DELAY_IN_MS);
    (0, react_1.useEffect)(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (!!selectedOrgUser && !!groupInfo) {
                try {
                    setIsLoading(true);
                    yield fetchLabRequisitions();
                }
                finally {
                    setIsLoading(false);
                }
            }
        }))();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOrgUser, groupInfo]);
    return {
        labRequisitions,
        isLoading,
    };
};
exports.useLabRequisitionList = useLabRequisitionList;
